module.exports = __webpack_public_path__ + "img/avatar-71.dc64325b.png";